// @owners { team: patients-team }
import { getBrand } from '@alto/design-system';
import { ALTO_PHONE, FUZE_HEALTH_PHONE } from '~shared/constants';

/**
 * Get the company phone number based on the current brand.
 * @returns string
 */
export const getCompanyPhone = () => {
  const brand = getBrand();

  if (brand === 'fuzehealth') {
    return FUZE_HEALTH_PHONE;
  }

  if (brand === 'alto') {
    return ALTO_PHONE;
  }

  throw new Error('Unknown brand');
};
